import { STANDARD_FOUR_TIME_ZONE_ID, UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { SessionTopicSpecialist } from '@interfaces';
import { DomainDataService } from '../../../../../../services';

export function getColumns(util: UtilityService, domainData: DomainDataService) {

	const columns: GridColumn<SessionTopicSpecialist & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Id', row => row.volunteerSignupSpecialistTopicId, { header: 'volunteerSignupSpecialistTopicId' }),
		buildColumn(util, 'FullName', row => `${row.person.fullName} `, { header: 'Name', width: 120 }),
		buildColumn(util, 'Text', row => row.volunteerSignupSpecialistStatus, { header: 'Status', width: 50 }),
		buildColumn(util, 'Text', row => row.standardFourTimeZoneId ? `${STANDARD_FOUR_TIME_ZONE_ID[row.standardFourTimeZoneId]} Time` : 'Not Provided', { header: 'Volunteer Timezone', width: 70 }),
		buildColumn(util, 'Text', row => (row.canVolunteerInEnglish && row.canVolunteerInSpanish) ? 'English and Spanish' : (row.canVolunteerInEnglish) ? 'English' : (row.canVolunteerInSpanish) ? 'Spanish' : 'None', { header: 'Approved Language(s)', width: 100 }),
		buildColumn(util, 'Text', row => row.canAttend, { header: 'Can Attend', width: 50 }),
	];

	return columns;

}